var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.page.title!='numbers' && _vm.page.title!='getintouch' )?_c('li',[_vm._v(" "+_vm._s(_vm.page.title)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }